export const labelSty = {
  fontFamily: 'Lexend',
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '23px',
  letterSpacing: '-0.23999999463558197px',
  textAlign: 'left',
  color: '#000',
  marginBottom: 1,
};

export const styInput = {
  paddingLeft: '8px',
  fontSize: '14px',
  fontFamily: 'Lexend',
  fontWeight: 400,
  borderRadius: '10px',
  backgroundColor: '#F5F7F9',
  color: '#000',
};

export const textareaSty = {
  padding: '12px',
  fontSize: '14px',
  fontFamily: 'Lexend',
  fontWeight: 400,
  borderRadius: '6px',
  border: 'none',
  backgroundColor: '#F5F7F9',
  color: '#000',
  outline: 'none',
};

export const labelStyles = {
  fontFamily: 'DM Sans',
  fontSize: '15px',
  fontWeight: 500,
  lineHeight: '18px',
  letterSpacing: '-0.23999999463558197px',
  textAlign: 'left',
  color: '#404E57',
  marginBottom: 1,
};
